module.exports = __webpack_public_path__ + "static/media/general-file.3fb69785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/general-file.svg
// module id = 476
// module chunks = 0 1